import { useReducer, createContext } from 'react'

export const ResidencyVerificationContext = createContext()

function setSession(state, payload) {
	return {
		...payload,
	}
}

const reducer = (state, action) => {
	switch (action.type) {
	case 'SET_SESSION':
		return setSession(state, action.payload)
	default:
		return state
	}
}

export const ResidencyVerificationContextProvider = (props) => {
	const [state, dispatch] = useReducer(reducer, {})

	return (
		<ResidencyVerificationContext.Provider value={[state, dispatch]}>
			{props.children}
		</ResidencyVerificationContext.Provider>
	)
}
